import React, { ImgHTMLAttributes } from 'react';

interface PointProps {
  number: number;
  position: 'left' | 'right';
  text: string[];
  textAditional?: string;
  imageElement: string;
}

export default class Point extends React.Component<PointProps> {
  render(): React.ReactNode {
    let numberSection = (
      <>
        <div className="number">{this.props.number}.</div>
      </>
    );

    let textSecition = (
      <div className="textSection">
        {this.props.position == 'left' ? <>{numberSection}</> : null}
        <div>
          <div>
            {this.props.text
              .map((item, index) => {
                return <span className="title">{item}</span>;
              })
              .reduce((prev, next) => (
                <>
                  {prev}
                  <br />
                  {next}
                </>
              ))}
          </div>
          {this.props.textAditional != undefined ? (
            <span>{this.props.textAditional}</span>
          ) : null}
        </div>
        {this.props.position == 'right' ? <>{numberSection}</> : null}
      </div>
    );
    let imagesection = <img src={this.props.imageElement} />;
    return this.props.position == 'left' ? (
      <div className="point">
        <div className="backgrund" />
        {textSecition}
        {imagesection}
      </div>
    ) : (
      <div className="point">
        <div className="backgrund" />
        {imagesection}
        {textSecition}
      </div>
    );
  }
}
